import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-fleetdiag-users',
  templateUrl: './fleetdiag-users.component.html',
  styleUrls: ['./fleetdiag-users.component.css'],
})
export class FleetdiagUsersComponent implements OnInit {
  userList = [];
  searchList = [];
  commandLogSearchList = [];
  commandLogList: any = [];
  pidLogList = [];
  pidLogSearchList = [];
  obdList = [];
  obdSearchList = [];

  mdl_Search: FormGroup = this._formBuilder.group({
    strSession: new FormControl(
      this._gurd.decrypt(localStorage.getItem('Session')!),
    ),
    iSystemUser: new FormControl(
      this._gurd.decrypt(localStorage.getItem('ID')!),
    ),
    iLog_SystemUser: new FormControl(''),
  });

  editForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(
      this._gurd.decrypt(localStorage.getItem('Session')!),
    ),
    iSystemUser: new FormControl(
      this._gurd.decrypt(localStorage.getItem('ID')!),
    ),
    strFullName: new FormControl({ value: '', disabled: true }),
    iFleetDiag_SystemUser: new FormControl(''),
    strEshterakRegisterDate: new FormControl({ value: '', disabled: true }),
    strEsterakEndDate: new FormControl(''),
    bEnable: new FormControl(false),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.getAllUsers();
  }

  getAllUsers = async () => {
    let model = this.mdl_Search.value;
    this._other.Showspinner();
    let res = JSON.parse(
      (
        await axios.post(
          `FleetDiag_SystemUser_List`,
          this._other.stringNumberToNumber(model),
        )
      ).data.toString(),
    );

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.userList = this.searchList = res;
  };

  filterResult(strValue: string) {
    if (strValue.length > 1) {
      this.userList = this.searchList.filter((el: any) => {
        return (
          el.strFullName.includes(strValue) || el?.strMobile.includes(strValue)
        );
      });
    } else if (strValue == '') {
      this.userList = this.searchList;
    }
  }

  openEditModal(item: any) {
    Object.keys(item).forEach((key) => {
      if (this.editForm.controls[key]) {
        this.editForm.controls[key].setValue(item[key]);
      }
    });
    this.editForm.controls['iFleetDiag_SystemUser'].setValue(item.iSystemUser);
    $('#EditModal').modal('show');
  }

  openCommandLog = async (item: any) => {
    this.mdl_Search.controls['iLog_SystemUser'].setValue(item.iSystemUser);

    const model = this.mdl_Search.value;

    this._other.Showspinner();
    let res = JSON.parse(
      (
        await axios.post(
          `FleetDiag_CommandLog_List`,
          this._other.stringNumberToNumber(model),
        )
      ).data.toString(),
    );
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }
    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.commandLogList = res;
    this.commandLogSearchList = res;
    $('#commandLogModal').modal('show');
  };

  filterCommandLog(strValue: string) {
    if (strValue.length > 1) {
      this.commandLogList = this.commandLogSearchList.filter((el: any) => {
        return (
          el?.strFullName?.includes(strValue) ||
          el?.strCommand?.toLowerCase().includes(strValue.toLowerCase())
        );
      });
    } else if (strValue == '') {
      this.commandLogList = this.commandLogSearchList;
    }
  }

  filterPidLog(strValue: string) {
    if (strValue.length > 1) {
      this.pidLogList = this.pidLogSearchList.filter((el: any) => {
        return (
          el?.strFullName?.includes(strValue) ||
          el?.strComment?.includes(strValue)
        );
      });
    } else if (strValue == '') {
      this.pidLogList = this.pidLogSearchList;
    }
  }

  openPidLog = async (item: any) => {
    this.mdl_Search.controls['iLog_SystemUser'].setValue(item.iSystemUser);

    const model = this.mdl_Search.value;

    this._other.Showspinner();
    let res = JSON.parse(
      (
        await axios.post(
          `FleetDiag_OBD2_PIDLog_List`,
          this._other.stringNumberToNumber(model),
        )
      ).data.toString(),
    );
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.pidLogList = res;
    this.pidLogSearchList = res;
    $('#pidLogModal').modal('show');
  };

  openDashboard = async (item: any) => {
    this.mdl_Search.controls['iLog_SystemUser'].setValue(item.iSystemUser);

    const model = this.mdl_Search.value;

    this._other.Showspinner();
    let res = JSON.parse(
      (
        await axios.post(
          `FleetDiag_OBD2_Code_List4Dashboard`,
          this._other.stringNumberToNumber(model),
        )
      ).data.toString(),
    );
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.obdList = res;
    this.obdSearchList = res;
    $('#obdModal').modal('show');
  };

  openWorkSpace = async (item: any) => {
    const URLTREE = this._router.createUrlTree(
      ['fleetdiag', item.iSystemUser, 'workspace'],
      {
        queryParams: {
          source: 'users'
        }
      }
    );
    const SERIALIZED_URL = this._router.serializeUrl(URLTREE)
    window.open(SERIALIZED_URL, '_blank')
  };

  submitEdit = async () => {
    const model = this._other.stringNumberToNumber(this.editForm.getRawValue());
    $.confirm({
      title: `آیا از ویرایش اطلاعات کاربر مطمئن هستید؟`,
      content: '',
      type: 'blue',
      buttons: {
        cancel: {
          text: 'انصراف',
        },
        ok: {
          text: 'ویرایش',
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            const resp = await axios.post(`FleetDiag_SystemUser_Edit`, model);
            resp.data = JSON.parse(resp.data);
            if (resp.data.ISSessionExpired == true) {
              this._tooltip.showError('لطفا وارد سیستم شوید');
              this._other.removeLocalStorage();
              this._router.navigate(['login'], {
                queryParams: { error: 'x12z110' },
              });
              return;
            }
            if (resp.data.iResult == 0) {
              this._tooltip.showError(resp.data.strError);
              return;
            }
            this._tooltip.showSuccess('با موفقیت ویرایش شد');
            this.getAllUsers();
            $('#EditModal').modal('hide');
            return;
          },
        },
      },
    });
  };

  exportExcel() {
    setTimeout(() => {
      let element = document.getElementById('Export_Excel');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'فیلیت دیاگ - کاربران.xlsx');
    }, 200);
  }

  exportExcelCommandLog() {
    setTimeout(() => {
      let element = document.getElementById('Export_Excel_CommandLog');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'لاگ فرامین.xlsx');
    }, 200);
  }

  exportExcelPidLog() {
    setTimeout(() => {
      let element = document.getElementById('Export_Excel_PidLog');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'سابقه فرامین.xlsx');
    }, 200);
  }

  openInNewTab(pid: string) {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/fleetdiag', 'dashboard', pid])
    );

    window.open(url, '_blank');
  }
}
